import { Grid } from '@material-ui/core';
import Truncate from 'components/Truncate';
import React from 'react';
import { useObservable } from 'react-use-observable';
import shoppingSubscriptionService from 'v2/services/shopping/subscription';

import useStyle from './../styles';

const SubscriptionDetails = () => {
  const classes = useStyle();
  const [shopping] = useObservable(() => shoppingSubscriptionService.getCurrent(), []);

  if (!shopping) return null;
  return (
    <>
      <div className={classes.quickviewDataBasic}>
        <Grid container spacing={2}>
          <Grid item md={4} sm={12} xs={12}>
            <div className='image' style={{ backgroundImage: `url(${shopping.product.image})` }}></div>
          </Grid>

          <Grid item md={8} sm={12} xs={12}>
            <div className='info'>
              <h2>{shopping.product.title}</h2>
              {!shopping?.producer.showProducerContactInformation && (
                <>
                  <div className='producer'>
                    Produtor:
                    <div className='data'>
                      <Truncate final='...' title={shopping?.producer.name} count={25}>
                        {shopping.producer.name}
                      </Truncate>
                    </div>
                    <div className='data'>
                      <Truncate final='...' title={shopping?.producer.email} count={25}>
                        {shopping.producer.email}
                      </Truncate>
                    </div>
                  </div>
                </>
              )}
            </div>
          </Grid>
        </Grid>

        <div className='m24'></div>

        <div className={classes.sender}>
          {shopping.customer.name && (
            <div className='data'>
              <span>Nome:</span> {shopping.customer.name}
            </div>
          )}
          {shopping.customer.email && (
            <div className='data'>
              <span>E-mail:</span> {shopping.customer.email}
            </div>
          )}
          {shopping.customer.celphone && (
            <div className='data'>
              <span>Fone:</span> {shopping.customer.celphone}
            </div>
          )}
          {shopping.payment_method.name && (
            <>
              <div className='data'>
                <span>Forma de pagamento:</span> {shopping.payment_method.name}
              </div>
            </>
          )}
          {shopping.card_number && (
            <>
              <div className='data'>
                <span>Cartão:</span> {shopping.card_number}
              </div>
            </>
          )}
          <div className='data'>
            <span>Tipo de frequência:</span> {shopping?.frequency_details?.frequency_type || '-'}
          </div>
          <div className='data'>
            <span>Frequência:</span> {shopping?.frequency_details?.frequency || '-'}
          </div>
          <div className='data'>
            <span>Limite de cobranças:</span> {shopping?.frequency_details?.number_of_charges || '-'}
          </div>
        </div>
      </div>
    </>
  );
};

export default SubscriptionDetails;
